/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConflictResolution } from './ConflictResolution';
import {
    ConflictResolutionFromJSON,
    ConflictResolutionFromJSONTyped,
    ConflictResolutionToJSON,
    ConflictResolutionToJSONTyped,
} from './ConflictResolution';

/**
 * 
 * @export
 * @interface ImportConfiguration
 */
export interface ImportConfiguration {
    /**
     * 
     * @type {string}
     * @memberof ImportConfiguration
     */
    defaultDateFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportConfiguration
     */
    numberFormat?: string | null;
    /**
     * 
     * @type {ConflictResolution}
     * @memberof ImportConfiguration
     */
    conflictResolution?: ConflictResolution;
    /**
     * 
     * @type {boolean}
     * @memberof ImportConfiguration
     */
    detectDuplicates?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ImportConfiguration
     */
    batchSize?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ImportConfiguration
     */
    customSettings?: { [key: string]: string; } | null;
}



/**
 * Check if a given object implements the ImportConfiguration interface.
 */
export function instanceOfImportConfiguration(value: object): value is ImportConfiguration {
    return true;
}

export function ImportConfigurationFromJSON(json: any): ImportConfiguration {
    return ImportConfigurationFromJSONTyped(json, false);
}

export function ImportConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'defaultDateFormat': json['defaultDateFormat'] == null ? undefined : json['defaultDateFormat'],
        'numberFormat': json['numberFormat'] == null ? undefined : json['numberFormat'],
        'conflictResolution': json['conflictResolution'] == null ? undefined : ConflictResolutionFromJSON(json['conflictResolution']),
        'detectDuplicates': json['detectDuplicates'] == null ? undefined : json['detectDuplicates'],
        'batchSize': json['batchSize'] == null ? undefined : json['batchSize'],
        'customSettings': json['customSettings'] == null ? undefined : json['customSettings'],
    };
}

export function ImportConfigurationToJSON(json: any): ImportConfiguration {
    return ImportConfigurationToJSONTyped(json, false);
}

export function ImportConfigurationToJSONTyped(value?: ImportConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'defaultDateFormat': value['defaultDateFormat'],
        'numberFormat': value['numberFormat'],
        'conflictResolution': ConflictResolutionToJSON(value['conflictResolution']),
        'detectDuplicates': value['detectDuplicates'],
        'batchSize': value['batchSize'],
        'customSettings': value['customSettings'],
    };
}

